import React, { useEffect } from 'react'
import Project from '../Components/Project'

export const Portfolio = () => {
  useEffect(() => {
    document.title = 'Abhinav - Portfolio';
  }, []);
  return (
    <div className='container'>
      <div className="section-mid">
        <Project />
      </div>
    </div>
  )
}
